/**
 * Adapts original ErrorBoundary component from swagger-ui:
 * https://github.com/swagger-api/swagger-ui/blob/4d9ec4fb0eaaddb7e1a8f4502e8e8577d40e46ec/src/core/plugins/safe-render/components/error-boundary.jsx#L7
 */
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import { Alert, Grid, Typography } from '@rbx/ui';
import DErrorMessage from './DErrorMessage';

export class DErrorBoundary extends Component {
  static getDerivedStateFromError() {
    return { hasError: true };
  }

  constructor(...args) {
    super(...args);
    this.state = { hasError: false };
  }

  componentDidCatch(_, errorInfo) {
    this.props.fn.componentDidCatch(_, errorInfo);
  }

  render() {
    const { children } = this.props;

    if (this.state.hasError) {
      return (
        <Grid container marginY={4}>
          <Alert variant='standard' severity='error'>
            <Typography variant='body1' color='inherit'>
              <DErrorMessage />
            </Typography>
          </Alert>
        </Grid>
      );
    }

    return children;
  }
}

export default DErrorBoundary;

DErrorBoundary.propTypes = {
  fn: PropTypes.any,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

DErrorBoundary.defaultProps = {
  fn: {
    // eslint-disable-next-line no-console
    componentDidCatch: console.error,
  },
  children: null,
};
